import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.map.js";
// Copyright 2017-2022 @polkadot/api authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { lazyMethod, logger, objectClear } from '@polkadot/util';
var l = logger('api/augment');

function logLength(type, values) {
  var and = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return values.length ? " ".concat(values.length, " ").concat(type).concat(and.length ? ' and' : '') : '';
}

function logValues(type, values) {
  return values.length ? "\n\t".concat(type.padStart(7), ": ").concat(values.sort().join(', ')) : '';
} // log details to console


function warn(prefix, type, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      added = _ref2[0],
      removed = _ref2[1];

  if (added.length || removed.length) {
    l.warn("api.".concat(prefix, ": Found").concat(logLength('added', added, removed)).concat(logLength('removed', removed), " ").concat(type, ":").concat(logValues('added', added)).concat(logValues('removed', removed)));
  }
}

function findSectionExcludes(a, b) {
  return a.filter(function (s) {
    return !b.includes(s);
  });
}

function findSectionIncludes(a, b) {
  return a.filter(function (s) {
    return b.includes(s);
  });
}

function extractSections(src, dst) {
  var srcSections = Object.keys(src);
  var dstSections = Object.keys(dst);
  return [findSectionExcludes(srcSections, dstSections), findSectionExcludes(dstSections, srcSections)];
}

function findMethodExcludes(src, dst) {
  var srcSections = Object.keys(src);
  var dstSections = findSectionIncludes(Object.keys(dst), srcSections);
  var excludes = [];

  var _loop = function _loop(s) {
    var section = dstSections[s];
    var srcMethods = Object.keys(src[section]);
    var dstMethods = Object.keys(dst[section]);
    excludes.push.apply(excludes, _toConsumableArray(dstMethods.filter(function (m) {
      return !srcMethods.includes(m);
    }).map(function (m) {
      return "".concat(section, ".").concat(m);
    })));
  };

  for (var s = 0; s < dstSections.length; s++) {
    _loop(s);
  }

  return excludes;
}

function extractMethods(src, dst) {
  return [findMethodExcludes(dst, src), findMethodExcludes(src, dst)];
}

function lazySection(src, dst) {
  var creator = function creator(m) {
    return src[m];
  };

  var methods = Object.keys(src);

  for (var i = 0; i < methods.length; i++) {
    var method = methods[i]; // We use hasOwnproperty here to only check for the existence of the key,
    // instead of reading dst[section][method] which will evaluate when already
    // set as a lazy value previously

    if (!Object.prototype.hasOwnProperty.call(dst, method)) {
      lazyMethod(dst, method, creator);
    }
  }
}
/**
 * @description Takes a decorated api section (e.g. api.tx) and augment it with the details. It does not override what is
 * already available, but rather just adds new missing items into the result object.
 * @internal
 */


export function augmentObject(prefix, src, dst) {
  var fromEmpty = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  fromEmpty && objectClear(dst); // NOTE: This part is slightly problematic since it will get the
  // values for at least all the sections and the names of the methods
  // (Since methods won't be decorated before lazy, this _may_ be ok)

  if (prefix && Object.keys(dst).length) {
    warn(prefix, 'modules', extractSections(src, dst));
    warn(prefix, 'calls', extractMethods(src, dst));
  }

  var sections = Object.keys(src);

  for (var i = 0; i < sections.length; i++) {
    var section = sections[i]; // We don't set here with a lazy interface, we decorate based
    // on the top-level structure (this bypasses adding lazy onto lazy)

    if (!dst[section]) {
      dst[section] = {};
    }

    lazySection(src[section], dst[section]);
  }

  return dst;
}